import { render, staticRenderFns } from "./ApplicationRelatedPersonsListItem.vue?vue&type=template&id=cf56a02a&lang=pug&"
import script from "./ApplicationRelatedPersonsListItem.vue?vue&type=script&lang=js&"
export * from "./ApplicationRelatedPersonsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports